import { msalInstance } from ".";
import { loginRequest } from "./authConfig";
import { createTheme } from '@fluentui/react/lib/Styling';
import { ICustomFieldDfn } from "./types";

export class AppGlobals {
    public static BuildNumber: string = '2026.04.27';
    public static EntraClientId: string | null = null;
    public static CustomerID: number | null = null;
    public static Username: string | null = null;
    public static UserID: number | null = null;
    public static CustomerTitle: string | null = null;
    public static CustomerSectorTitle: string | null = null;
    public static CustomerRef: string | null = null;
    public static UserTitle: string | null = null;
    public static AuthType: string | null = null;
    public static CustomJwtToken: string | null = null;
    public static DemoUserEmail: string | null = null;

    public static readonly ZedxNetSiteUrl: string = process.env.REACT_APP_ZedX_Net!;


    public static acquireAccessToken = async () => {

        if (this.AuthType === 'CustomJwt') {
            return this.CustomJwtToken;
            //return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJuYmYiOjE3MDE3NzYwNDAsImV4cCI6MTcwMjM4MDg0MCwiaWF0IjoxNzAxNzc2MDQwfQ.mtSoeMKKBnOqeA7WCwJUs-cKk8eEoGA1SyU0f47hUHc";
        }
        else {
            //const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
            const accounts = msalInstance.getAllAccounts();
            console.log('all accounts', accounts);

            // if (!activeAccount && accounts.length === 0) {
            //     /*
            //     * User is not signed in. Throw error or wait for user to login.
            //     * Do not attempt to log a user in outside of the context of MsalProvider
            //     */
            // }
            const request = {
                ...loginRequest,
                account: accounts[0]
            };

            const authResult = await msalInstance.acquireTokenSilent(request);
            //console.log('authResult', authResult);

            return authResult.accessToken;
        }
    };
}

export const darkTheme = createTheme({
    palette: {
        themePrimary: '#ffffff',
        themeLighterAlt: '#f3f3f3',
        themeLighter: '#dcdcdc',
        themeLight: '#c8c8c8',
        themeTertiary: '#a6a6a6',
        themeSecondary: '#868686',
        themeDarkAlt: '#6e6e6e',
        themeDark: '#555555',
        themeDarker: '#3f3f3f',
        neutralLighterAlt: '#2b2b2b',
        neutralLighter: '#323232',
        neutralLight: '#3f3f3f',
        neutralQuaternaryAlt: '#484848',
        neutralQuaternary: '#4f4f4f',
        neutralTertiaryAlt: '#6d6d6d',
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#ffffff',
        white: '#494949',
    },
});

export const darkBlueTheme = createTheme({
    palette: {
        themePrimary: '#ffffff',
        themeLighterAlt: '#f3f3f3',
        themeLighter: '#dcdcdc',
        themeLight: '#c8c8c8',
        themeTertiary: '#a6a6a6',
        themeSecondary: '#868686',
        themeDarkAlt: '#6e6e6e',
        themeDark: '#555555',
        themeDarker: '#3f3f3f',

        //
        // NAV BACKGROUND + HOVER + SELECTED COLORS (UPDATED)
        //

        // Lightest hover
        neutralLighterAlt: '#1A325B',

        // Hover color
        neutralLighter: '#0E4A8C',

        // Selected item background
        neutralLight: '#1A619F',       // <-- your requested selected blue

        // Slightly darker shades (used sometimes for borders)
        neutralQuaternaryAlt: '#162A4D',
        neutralQuaternary: '#142649',
        neutralTertiaryAlt: '#122141',

        //
        // TEXT COLORS (ALL ORIGINAL — unchanged)
        //
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#ffffff',

        //
        // MAIN NAV BACKGROUND
        //
        white: '#08366A',   // your new background base
    },
});

export const darkBlackTheme = createTheme({
    palette: {
        //
        // PRIMARY (not used heavily in nav, kept neutral)
        //
        themePrimary: '#ffffff',
        themeLighterAlt: '#f2f2f2',
        themeLighter: '#d6d6d6',
        themeLight: '#bfbfbf',
        themeTertiary: '#8c8c8c',
        themeSecondary: '#595959',
        themeDarkAlt: '#404040',
        themeDark: '#262626',
        themeDarker: '#0d0d0d',

        //
        // NAV BACKGROUND + HOVER + SELECTED
        //

        // Lightest hover (rarely used)
        neutralLighterAlt: '#1A1A1A',

        // Hover color
        neutralLighter: '#1E1E1E',

        // Selected item background
        neutralLight: '#2A2A2A',

        // Borders / separators
        neutralQuaternaryAlt: '#181818',
        neutralQuaternary: '#151515',
        neutralTertiaryAlt: '#131313',

        //
        // TEXT COLORS
        //
        neutralTertiary: '#cfcfcf',
        neutralSecondary: '#d6d6d6',
        neutralPrimaryAlt: '#e0e0e0',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#ffffff',

        //
        // MAIN NAV BACKGROUND
        //
        white: '#121212',
    },
});

export const darkSlateTheme = createTheme({
    palette: {
        //
        // PRIMARY
        //
        themePrimary: '#ffffff',
        themeLighterAlt: '#f2f4f7',
        themeLighter: '#d9dde3',
        themeLight: '#bfc6cf',
        themeTertiary: '#8a96a6',
        themeSecondary: '#5f6b7a',
        themeDarkAlt: '#46505e',
        themeDark: '#2f3742',
        themeDarker: '#1c222b',

        //
        // NAV BACKGROUND + HOVER + SELECTED
        //

        // Lightest hover
        neutralLighterAlt: '#26303B',

        // Hover
        neutralLighter: '#2A3441',

        // Selected
        neutralLight: '#344155',

        // Borders / dividers
        neutralQuaternaryAlt: '#222A34',
        neutralQuaternary: '#202833',
        neutralTertiaryAlt: '#1D242E',

        //
        // TEXT COLORS (WHITE)
        //
        neutralTertiary: '#C7CED8',
        neutralSecondary: '#D1D7E0',
        neutralPrimaryAlt: '#E2E8F0',
        neutralPrimary: '#FFFFFF',
        neutralDark: '#F8FAFC',
        black: '#FFFFFF',

        //
        // MAIN NAV BACKGROUND
        //
        white: '#1F2933',
    },
});


export const lightSlateTheme = createTheme({
    palette: {
        //
        // PRIMARY
        //
        themePrimary: '#1F2937',
        themeLighterAlt: '#f7f9fb',
        themeLighter: '#e3e8ee',
        themeLight: '#ccd5df',
        themeTertiary: '#9aa8b8',
        themeSecondary: '#64748b',
        themeDarkAlt: '#475569',
        themeDark: '#334155',
        themeDarker: '#1e293b',

        //
        // NAV BACKGROUND + HOVER + SELECTED
        //

        // Very light hover
        neutralLighterAlt: '#EEF2F6',

        // Hover
        neutralLighter: '#E6EBF1',

        // Selected item (neutral, not bluish)
        neutralLight: '#E0E4E8',

        // Borders / separators
        neutralQuaternaryAlt: '#E2E5E9',
        neutralQuaternary: '#D5DAE0',
        neutralTertiaryAlt: '#C9D0D8',

        //
        // TEXT
        //
        neutralTertiary: '#4B5563',
        neutralSecondary: '#374151',
        neutralPrimaryAlt: '#1F2937',
        neutralPrimary: '#111827',
        neutralDark: '#0F172A',
        black: '#000000',

        //
        // MAIN NAV BACKGROUND
        //
        white: '#F4F6F8',
    },
});

export const AppIDs = {
    CORWF: 1,
    PROJPORT: 2,
    RISKREG: 3,
    GIAA: 4,
    NAO: 5,
    CL: 6,
    GO: 7,
    MA: 8,
    CA: 9,
    AGSPR: 10,
    KNHUB: 11,
    GRPNOTI: 12
} as const;

export const getAppKeyByValue = (value: number): string | undefined =>
    Object.keys(AppIDs).find(key => AppIDs[key as keyof typeof AppIDs] === value);


export const getAppName = (
    menuData: any[],
    appId: number,
    defaultValue: string = ''
): string => {
    const app = menuData.find(m => m.ID === appId);
    return app ? app.AppName : defaultValue;
};

export const CUSTOM_FIELD_SCOPES = [
    'All Apps - Common',

    'All Delivery Apps - Portfolio',
    'All Delivery Apps - Programmes',
    'All Delivery Apps - Projects',
    'All Delivery Apps - WorkStreams',

    'Project Portfolios - Benefits',
    'Project Portfolios - Dependencies',
    'Project Portfolios - Milestones',

    'Agile Sprints - Epics',
    'Agile Sprints - Sprints',
    'Agile Sprints - Work Items',

    'Group Workstreams - Epics',
    'Group Workstreams - Work Items',

    'Risk Register - Common',
    'Risk Register - Risks',
    'Risk Register - Issues',
    'Risk Register - Incidents',
] as const;

export type CustomFieldScope = typeof CUSTOM_FIELD_SCOPES[number];

export const getFilteredCustomFieldDfns = (
    customFieldDfns: ICustomFieldDfn[] = [],
    allowedScopes: string[]
) => {
    return customFieldDfns.filter(
        f => f.Scope != null && allowedScopes.includes(f.Scope)
    );
};
